import React from 'react';
import Column from '@amzn/meridian/column';
import ViewOutboundVolumes from '../../common/ssd/outboundVolumes/ViewOutboundVolumes';
import ViewOutboundVolumesByBusiness from '../../common/ssd/outboundVolumes/ViewOutboundVolumesByBusiness';
import Text from '@amzn/meridian/text';
import NavigationButtons from '../../../commonComponents/NavigationButtons';
import { isFeatureFlagEnabled } from '../../utils';
import { SSD_FEATURE_FLAGS_LIST } from '../../../../utils/constants';

const VerifyOutboundVolumes = ({ currentUser, plan, setPlan, onGoNext, onCancel }) => {
  const isGroceryEnabled = isFeatureFlagEnabled(plan.input.adminSettings, SSD_FEATURE_FLAGS_LIST.groceryEnabled, false);
  const isRushEnabled = isFeatureFlagEnabled(plan.input.adminSettings, SSD_FEATURE_FLAGS_LIST.rushEnabled, false);

  return (
    <Column width="100%">
      {!isGroceryEnabled && !isRushEnabled && (
        <React.Fragment>
          <Text type={'h400'}>Outbound Volume</Text>
          <Text type={'b400'}>Verify or update the values below and submit.</Text>
          <ViewOutboundVolumes currentUser={currentUser} isEditable={true} plan={plan} setPlan={setPlan} />
        </React.Fragment>
      )}

      {(isGroceryEnabled || isRushEnabled) && (
        <ViewOutboundVolumesByBusiness currentUser={currentUser} isEditable={true} plan={plan} setPlan={setPlan} />
      )}

      <NavigationButtons onNext={onGoNext} onCancel={onCancel} showCancel={true} />
    </Column>
  );
};

export default VerifyOutboundVolumes;
